/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import Profile from '@/packages/profile';

import { Component, Vue } from 'vue-property-decorator';
import { Cell, CellGroup } from 'vant';
import { UserPo } from '@/po/user';
import UserModulesApi from '@/api/userModules';
import { checkAuthManagement } from '@/api/rights';
import { ZMoneyVirtualId, MembersRightsPrefix } from '@/constant';
import { AuthStatusEnum } from '@/enums/auth-status';
import { RouterV2Enum } from '@/router/router-names';
import { session } from '@/shared/utils/storage';
import { SessionEnum } from '@/enums/session';
import platform from '@/shared/utils/platform';
import { logout, openInnerPage } from '@/api/native/utils';
import { jumpToNewVersion } from '@/shared/utils/jumpTo';
import { NewVersionEnum } from '@/enums/newVersionRoute';
import { platformIdentityManager } from '@/shared/identity-verification';
import { AuthSceneTypeEnum } from '@/shared/identity-verification/types';
import jumpToVerifyCredit from '@/shared/verify-credit-controller';
import { VerifySceneEnum } from '@/shared/verify-credit-controller/types';
import { getGalileoAb } from '@/shared/galileoAb';
import { ExperimentResEnum } from '@/enums/abExperiment';
import { isFinanceWechatMini } from '@/api/native/wechat';


import URLUtils from '@/shared/utils/URLUtils';

const style = require('./index.module.scss');

@Component
export default class Setting extends Vue {
  private authList: UserPo.AuthModule[] = [];

  // 是否有授权项 是否展示授权管理
  private hasAuthItem = false;

  private get baseInfoStatus(): AuthStatusEnum | null {
    const baseInfoItem = this.authList.find(
      (item) => item.userModule === 'personal_info',
    );

    return baseInfoItem ? baseInfoItem.authStatus : null;
  }

  private get contactInfoStatus(): AuthStatusEnum | null {
    const contactInfoItem = this.authList.find(
      (item) => item.userModule === 'contact_info',
    );

    return contactInfoItem ? contactInfoItem.authStatus : null;
  }

  private get identityStatus(): AuthStatusEnum | null {
    const identityItem = this.authList.find(
      (item) => item.userModule === 'id_card_info',
    );

    return identityItem ? identityItem.authStatus : null;
  }

  private render() {
    return (
      <section class={style.settingContainer}>
        <Profile fontColor={'#333'} backgroundColor={'#fff'} hiddenIcon/>

        <CellGroup>
          <Cell title="个人信息" isLink onClick={this.goProfileModify.bind(this)}>
            <span slot="icon" class={[style.icon, style.baseInfoIcon]} />
            <span slot="right-icon" class={style.rightIcon} />
            {this.baseInfoStatus && (
              <span
                class={[
                  style.cellValue,
                  this.baseInfoStatus !== AuthStatusEnum.SUCCESS
                    && style.emphaseCellValue,
                ]}
              >
                {this.baseInfoStatus === AuthStatusEnum.SUCCESS
                  ? '已保存'
                  : '未保存'}
              </span>
            )}
          </Cell>
          <Cell title="联系人信息" isLink onClick={this.goContractInfo.bind(this)}>
            <span slot="icon" class={[style.icon, style.contactInfoIcon]} />
            <span slot="right-icon" class={style.rightIcon} />
            {this.contactInfoStatus && (
              <span
                class={[
                  style.cellValue,
                  this.contactInfoStatus !== AuthStatusEnum.SUCCESS
                    && style.emphaseCellValue,
                ]}
              >
                {this.contactInfoStatus === AuthStatusEnum.SUCCESS
                  ? '已保存'
                  : '未保存'}
              </span>
            )}
          </Cell>
          <Cell title="实名认证" isLink onClick={this.goIdentity.bind(this)}>
            <span slot="icon" class={[style.icon, style.identityIcon]} />
            <span slot="right-icon" class={style.rightIcon} />
            {this.identityStatus && (
              <span
                class={[
                  style.cellValue,
                  this.identityStatus !== AuthStatusEnum.SUCCESS
                    && style.emphaseCellValue,
                ]}
              >
                {this.identityStatus === AuthStatusEnum.SUCCESS
                  ? '已保存'
                  : '未保存'}
              </span>
            )}
          </Cell>
          <Cell title="银行卡" isLink onClick={this.goBankList.bind(this)}>
            <span slot="icon" class={[style.icon, style.bankIcon]} />
            <span slot="right-icon" class={style.rightIcon} />
          </Cell>
          <Cell title="补充资料" isLink onClick={this.goAdditionalInfo.bind(this)}>
            <span slot="icon" class={[style.icon, style.moreInfoIcon]} />
            <span slot="right-icon" class={style.rightIcon} />
          </Cell>
        </CellGroup>

        <CellGroup>
          <Cell title="账户安全" isLink onClick={this.goSecurity.bind(this)}>
            <span slot="icon" class={[style.icon, style.securityIcon]} />
            <span slot="right-icon" class={style.rightIcon} />
          </Cell>
          {!(platform.isAlipayMini || platform.isDingTalk)
          && <Cell title="关于我们" isLink onClick={this.goAboutUsList.bind(this)}>
            <span slot="icon" class={[style.icon, style.aboutUsIcon]} />
            <span slot="right-icon" class={style.rightIcon} />
          </Cell>
          }
          <Cell
            title="法律条款及隐私政策"
            isLink
            onClick={this.onLegalContract.bind(this)}
          >
            <span slot="icon" class={[style.icon, style.userInfo]} />
            <span slot="right-icon" class={style.rightIcon} />
          </Cell>
        </CellGroup>

        {!platform.isSkApp && <CellGroup>
          <Cell title="营销设置" isLink onClick={this.goMarketing.bind(this)}>
            <span slot="icon" class={[style.icon, style.marketing]} />
            <span slot="right-icon" class={style.rightIcon} />
          </Cell>
          {
            this.hasAuthItem && (
              <Cell title="授权管理" isLink onClick={this.goAuthManagement.bind(this)}>
                <span slot="icon" class={[style.icon, style.authIcon]} />
                <span slot="right-icon" class={style.rightIcon} />
              </Cell>
            )
          }
        </CellGroup>}

        {(platform.isSkApp || isFinanceWechatMini()) && (
          <CellGroup>
            <Cell title="退出登录" center>
              <div slot="title" class={style.logout} >
                <span onClick={this.logout.bind(this)}>退出登录</span>
              </div>
            </Cell>
          </CellGroup>
        )}
      </section>
    );
  }

  private async mounted() {
    checkAuthManagement().then((res) => {
      this.hasAuthItem = res;
    });
    this.authList = await UserModulesApi.getAuthInfo(ZMoneyVirtualId);
  }

  // 法律协议
  private onLegalContract() {
    this.$ubtPageButton('查看法律协议');
    this.$router.push({
      path: RouterV2Enum.legalConstract,
    });
  }

  private goProfileModify() {
    this.$ubtPageButton('臻有钱_设置_个人信息');

    jumpToVerifyCredit(VerifySceneEnum.PERSONAL_PROFILE_MODIFY);
  }

  private goContractInfo() {
    this.$ubtPageButton('finance_loan_setting_contactInfo');

    jumpToVerifyCredit(VerifySceneEnum.PERSONAL_CONTACT_MODIFY);
  }

  private goAuthManagement() {
    this.$ubtPageButton('finance_loan_setting_authManagement');

    const rightsUrl = URLUtils.formatUrl(
      `${MembersRightsPrefix}auth-management.html#/auth-management`,
      {},
    );
    openInnerPage(rightsUrl);
  }

  private goMarketing() {
    jumpToNewVersion(NewVersionEnum.MARKETING_SETTINGS, false);
  }

  private async goIdentity() {
    this.$ubtPageButton('臻有钱_设置_实名认证');

    await platformIdentityManager.checkUserAuth(AuthSceneTypeEnum.EDIT);

    jumpToVerifyCredit(VerifySceneEnum.PERSONAL_IDENTITY_MODIFY);
  }

  private goBankList() {
    this.$ubtPageButton('臻有钱_设置_银行卡');

    session.set(SessionEnum.toBindCard, {
      from: 'profile',
      back: this.$route.fullPath,
    });

    this.$router.push({
      path: RouterV2Enum.cardList,
      query: {
        from: 'profile',
      },
    });
  }

  private goSecurity() {
    this.$ubtPageButton('臻有钱_设置_银行卡');

    this.$router.push({
      path: RouterV2Enum.security,
    });
  }

  private goAboutUsList() {
    this.$ubtPageButton('臻有钱_设置_关于我们');

    this.$router.push({
      path: RouterV2Enum.aboutUsList,
    });
  }

  private goAdditionalInfo() {
    this.$ubtPageButton('finance_loan_setting_addInformation');

    this.$router.push({
      path: RouterV2Enum.supplementInfo,
    });
  }

  /** 退出登录 */
  private logout() {
    logout();
  }
}
